import { render, staticRenderFns } from "./TwitchLogoIcon.vue?vue&type=template&id=4a2a5b76"
import script from "./TwitchLogoIcon.vue?vue&type=script&lang=js"
export * from "./TwitchLogoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports